import { useState } from "react"
import { motion, AnimatePresence } from "framer-motion"
import emailjs from "emailjs-com"
import Reveal, { SectionLabel } from "./Reveal"
import { EMAIL, LINKEDIN, WHATSAPP_DISPLAY, whatsappLink } from "./data"

const interesses = ["Site", "E-commerce", "Sistema", "Tráfego / SEO", "Outro"]

const FaleConosco = () => {
  const [email, setEmail] = useState("")
  const [duvida, setDuvida] = useState("")
  const [interesse, setInteresse] = useState(null)
  const [enviado, setEnviado] = useState(false)
  const [error, setError] = useState(null)
  const [isSending, setIsSending] = useState(false)

  const reset = () => {
    setEnviado(false)
    setError(null)
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setIsSending(true)

    const templateParams = {
      email,
      duvida: interesse ? `[Interesse: ${interesse}]\n\n${duvida}` : duvida,
    }

    try {
      await emailjs.send("service_1b4egvg", "template_gfvpg5z", templateParams, "ogCxq1TLPzdgKUj5x")
      setEnviado(true)
      setEmail("")
      setDuvida("")
      setInteresse(null)
      setError(null)
    } catch (err) {
      console.error("Erro ao enviar o email:", err)
      setError("Erro ao enviar o email. Por favor, tente novamente.")
    } finally {
      setIsSending(false)
    }
  }

  return (
    <section className="k-section k-contact" id="contato">
      <div className="k-container k-contact__inner">
        <Reveal className="k-contact__intro">
          <SectionLabel index="05" light>
            Contato
          </SectionLabel>
          <h2 className="k-contact__title">
            Vamos <em>conversar?</em>
          </h2>
          <p>Conte sua ideia. Respondemos rápido, com uma proposta clara e sem compromisso.</p>

          <ul className="k-channels">
            <li>
              <a href={whatsappLink("Olá! Vim pelo site da KJR e gostaria de um orçamento.")} target="_blank" rel="noopener noreferrer">
                <small>WhatsApp</small>
                <span>{WHATSAPP_DISPLAY}</span>
                <i aria-hidden>↗</i>
              </a>
            </li>
            <li>
              <a href={`mailto:${EMAIL}`}>
                <small>E-mail</small>
                <span>{EMAIL}</span>
                <i aria-hidden>↗</i>
              </a>
            </li>
            <li>
              <a href={LINKEDIN} target="_blank" rel="noopener noreferrer">
                <small>LinkedIn</small>
                <span>/kjr-desenvolvimento</span>
                <i aria-hidden>↗</i>
              </a>
            </li>
          </ul>
        </Reveal>

        <Reveal delay={0.1}>
          <form className="k-form" onSubmit={handleSubmit}>
            <fieldset className="k-form__group">
              <legend>O que você precisa?</legend>
              <div className="k-form__chips">
                {interesses.map((i) => (
                  <button
                    type="button"
                    key={i}
                    className={interesse === i ? "is-active" : ""}
                    aria-pressed={interesse === i}
                    onClick={() => {
                      setInteresse(interesse === i ? null : i)
                      reset()
                    }}
                  >
                    {i}
                  </button>
                ))}
              </div>
            </fieldset>

            <label className="k-field">
              <span>Seu melhor e-mail</span>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value)
                  reset()
                }}
                placeholder="voce@empresa.com.br"
                required
              />
            </label>

            <label className="k-field">
              <span>Conte sobre o projeto ou sua dúvida</span>
              <textarea
                name="duvida"
                rows={5}
                value={duvida}
                onChange={(e) => {
                  setDuvida(e.target.value)
                  reset()
                }}
                placeholder="Ex.: preciso de um site institucional com 5 páginas e integração com WhatsApp..."
                required
              />
            </label>

            <button type="submit" className="k-btn k-btn--accent k-btn--block" disabled={isSending || !email || !duvida}>
              {isSending ? (
                <>
                  <span className="k-spinner" /> Enviando...
                </>
              ) : (
                <>
                  Enviar mensagem <span className="k-btn__arrow">→</span>
                </>
              )}
            </button>

            <AnimatePresence>
              {enviado && (
                <motion.p className="k-form__msg is-ok" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}>
                  Mensagem enviada com sucesso! Entraremos em contato em breve.
                </motion.p>
              )}
              {error && (
                <motion.p className="k-form__msg is-error" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}>
                  {error}
                </motion.p>
              )}
            </AnimatePresence>
          </form>
        </Reveal>
      </div>
    </section>
  )
}

export default FaleConosco
